const ACTIVE_EXTERNAL_ACTION = 'AD_CONVERT_TYPE_ACTIVE'
const ACTIVE_ROI_DEEP_EXTERNAL_ACTION = 'AD_CONVERT_TYPE_LT_ROI'
const ROI_COEFFICIENT_DEEP_BID_TYPE = 'ROI_COEFFICIENT'

/**
 * 根据优化目标给出默认深度优化目标；激活默认 ROI，但保留用户清空的入口。
 *
 * @param {string|null} externalAction 优化目标
 * @returns {string|null} 默认深度优化目标
 */
function getDefaultDeepExternalAction(externalAction) {
    if (externalAction === ACTIVE_EXTERNAL_ACTION) {
        return ACTIVE_ROI_DEEP_EXTERNAL_ACTION
    }

    return null
}

/**
 * 根据深度优化目标同步深度优化方式，避免取消深度目标后提交无效 deep_bid_type。
 *
 * @param {string|null} deepExternalAction 深度优化目标
 * @returns {string|null} 深度优化方式
 */
function getDeepBidTypeByDeepExternalAction(deepExternalAction) {
    return deepExternalAction ? ROI_COEFFICIENT_DEEP_BID_TYPE : null
}

/**
 * 归一化深度优化目标，避免 allow-clear 产生 undefined 进入最终提交对象。
 *
 * @param {string|null|undefined} deepExternalAction 深度优化目标
 * @returns {string|null} 归一后的深度优化目标
 */
function normalizeDeepExternalAction(deepExternalAction) {
    return deepExternalAction || null
}

/**
 * 判断激活无深度目标是否需要阻断提交；当前业务允许提交普通激活项目。
 *
 * @returns {boolean} 是否阻断提交
 */
function shouldBlockActiveWithoutDeepExternalAction() {
    return false
}

module.exports = {
    ACTIVE_EXTERNAL_ACTION,
    ACTIVE_ROI_DEEP_EXTERNAL_ACTION,
    ROI_COEFFICIENT_DEEP_BID_TYPE,
    getDefaultDeepExternalAction,
    getDeepBidTypeByDeepExternalAction,
    normalizeDeepExternalAction,
    shouldBlockActiveWithoutDeepExternalAction,
}
